import { Column } from '@melements/front-components';
import styled from 'theme';

export const TppInfoLabel = styled.label`
  font-size: ${p => p.theme.variables.fonts.size.bigger0};
  font-weight: ${p => p.theme.variables.fonts.weight.bold};
  line-height: 3;
  color: ${p => p.theme.variables.customColors.leadingColor.base};
  padding-bottom: 0.5rem;
  margin-top: 1rem;
`;

export const TppInfoColumn = styled(Column)`
  padding-top: 1rem;
`;
